export const forceAdminNotRequiredFields = ["program_code"];
